import { type ModalController } from "../model/types";

let controller: ModalController | null = null;

export const setModalController = (nextController: ModalController | null) => {
    controller = nextController;
};

export const getModalController = () => controller;
